import { createRouter, createWebHistory } from 'vue-router'
import { useAppStore } from '@/stores/AppStore'
import publicRoutes from './public'
import authRoutes from './auth'
import xpressRoutes from './xpress'
// import { is_line_express } from '@/stores/Constant'
// import { getParamsFromLiffUrl } from '@/utils'

const fallbackRoute = [
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/public/NotFound.vue'),
  },
]

const routes = [...publicRoutes, ...authRoutes, ...xpressRoutes, ...fallbackRoute]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    return savedPosition || { top: 0 }
  },
})

// function _checkIsXpress() {
//   const appStore = useAppStore()
//   if (!appStore.isInit) {
//     // โหลดเสร็จแล้ว
//     return appStore.isXpress
//   } else {
//     // กรณีที่โหลดยังไม่เสร็จ (เช่นใน beforeEach (ที่ทำงานเร็วกว่า App.vue)) จะเช็คจาก URL โดยตรง
//     console.warn('AppStore is not initialized yet. Manually checking URL for isXpress.')
//     const params = getParamsFromLiffUrl(window.location.search)
//     const channelId = params.get('channelId') as string
//     return is_line_express(channelId)
//   }
// }

/*
  Careful route guard logic is checking faster than AppStore update from App.vue
*/
router.beforeEach((to, _from) => {
  // const isXpress = _checkIsXpress()

  // Allow public routes and NotFound without check
  // public = /public/* and /feedback
  // Use includes() to handle LIFF paths which are prefixed with the LIFF ID (e.g. /{liff_id}/public/...)
  // ex. https://liff.line.me/${jeraConfig.liff_id}/${path}/
  // const isPublicRoute = to.path.includes('/public') || to.path.includes('/feedback')
  // if (isPublicRoute || to.name === 'NotFound') {
  //   return true
  // }

  // const isXpressRoute = to.path.startsWith('/xpress')
  // if (isXpress && !isXpressRoute) {
  //   return { path: '/not-found' }
  // }

  // if (!isXpress && isXpressRoute) {
  //   return { path: '/not-found' }
  // }

  const appStore = useAppStore()
  document.title = (to.meta?.title as string) ?? (appStore.isXpress ? 'AURA XPRESS LINE CRM' : 'AURA LINE CRM')

  return true
})

export default router
